import { render, staticRenderFns } from "./FinancialMerchantChannelStatistics.vue?vue&type=template&id=59811965&"
import script from "./FinancialMerchantChannelStatistics.vue?vue&type=script&lang=ts&"
export * from "./FinancialMerchantChannelStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FinancialMerchantChannelStatistics.vue"
export default component.exports